import { Routes } from '@models/route';
import { lazy } from 'react';

const LeadsListing = lazy(() =>
  import('@pages/leads/LeadsListing').then((p) => ({ default: p.LeadsListing }))
);
const LeadDetails = lazy(() =>
  import('@pages/leads/LeadDetails').then((p) => ({
    default: p.LeadDetails,
  }))
);

export const LeadRoutes: Routes = [
  {
    path: 'leads',
    component: LeadsListing,
    children: [
      {
        path: ':id',
        component: LeadDetails,
      },
    ],
  },
];
